import React from 'react'
import Banner from '../../components/Banner'
import HomeHeader from '../../components/HomeHeader';
import HomeTopBar from '../../components/HomeTopBar';
import Layout from '../Layout';
import CustomerForm from './CustomerForm';

const CustomerRegistration = () => {

    return (
        <Layout head={"CUSTOMER REGISTRATION"}>
            <CustomerForm/>   
        </Layout>
    )
}

export default CustomerRegistration
